import request from '@/utils/request'
import { downloadBlob } from '../../utils/helpers'
import uuid from 'uniq-id'

export default {
    getBalanceHistories: async({ dispatch, commit }, params) => {
        commit('balanceHistory/SET_LOAD', true, { root: true })
        await request({
            method: 'get',
            url: '/admin/balance-history',
            responseType: params.excel ? 'blob' : 'json',
            params: {
                ...Object.select(params, [
                    'fromDate', 'toDate', 'toDate', 'clientId', 'taxiOrderId',
                    'paymentId', 'phoneNumber', 'paymentType', 'orderType',
                    'page', 'column', 'direction', 'excel'
                ])
            }
        })
            .then(res => {
                if (res.data && res.data.balanceHistories) {
                    commit('SET_PAGINATION', {
                        length: res.data.totalPages,
                        page: res.data.page,
                        total: res.data.total
                    })
                    commit('SET_BALANCE_HISTORIES', res.data.balanceHistories)
                    commit('SET_LOAD', false)
                } else if (res.data && params.excel) {
                    downloadBlob(res.data, `Report_${uuid()}.xlsx`)
                }
            }).finally(() => {
                commit('SET_LOAD', false)
            })
    },
    refillClientBalance: async({ dispatch, commit }, refillData) => {
        return await request({ method: 'post', url: '/client/refill', data: {
            ...Object.select(refillData, ['phoneNumber', 'amount', 'comment'])
        }})
            .then(res => {
                commit('ADD_TO_BALANCE_HISTORIES', res.data)
                dispatch('addMessage', {
                    message: 'refillBalance',
                    type: 'success',
                    locale: true
                }, { root: true })
                return res
            })
            .catch(err => {
                if (err.response && err.response.data && err.response.data.message) {
                    dispatch('addMessage', {
                        message: err.response.data.message,
                        locale: true
                    }, { root: true })
                }
            })
    }
}
